import React from "react";
import { PASSWORD_RULES } from "../../utils/passwordPolicy";

export default function PasswordRequirements({ password }: { password: string }) {
  return (
    <ul className="mb-4 mt-1 space-y-1 rounded-sm border border-slate-200 bg-slate-50 p-3 text-xs">
      <p className="mb-2 font-medium text-slate-700">Password must include:</p>
      {PASSWORD_RULES.map((rule) => {
        const met = password.length > 0 && rule.test(password);
        return (
          <li
            key={rule.id}
            className={
              met ? "text-green-700 flex gap-2" : "text-slate-500 flex gap-2"
            }
          >
            <span aria-hidden>{met ? "✓" : "○"}</span>
            <span>{rule.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
